// authService.js
import api from '../api';

export const login = async (username, password) => {
    try {
      const response = await api.post('/auth/login', { email: username, password });
        console.log(response.data,'asdkasdas')
      if (response.data) {
        if (!response.data.approved) {
          // User not approved: navigate to "Not Approved" page
           // Assuming you have a route for this page
          return response.data.approved;
        }else{
            // User approved: return user data and potentially navigate to dashboard
            return response.data; // Assuming data contains user information
        }
      }
  
      throw new Error('Invalid credentials or login failed'); // Handle other errors
    } catch (error) {
      throw error.response ? error.response.data : error; // Rethrow error for handling
    }
  };
export const signup = async (firstName, lastName, email, password, phone, username) => {
    try {
      const response = await api.post('/auth/signup', { firstName, lastName, email, password, phone, username });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  };
export const adminLogin = async (username, password) => {
    try {
        const response = await api.post('/admin/login', { email:username, password });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
};

export const adminCreateProduct = async(data)=>{
    try {
        const response = await api.post('/products/create', data);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
}


export const getProduct = async()=>{
    try {
        const response = await api.get('/products/');
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
}


export const updatedProduct = async(data)=>{
    try {
        const response = await api.put(`/products/${data.id}`,data);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
}

export const deleteProduct = async(data)=>{
    try{
        const response = await api.delete(`/products/${data.id}`);
        return response.data;
    }
    catch(error){
        throw error.response ? error.response.data : error;
        
    }
}


export const fetchAllSubmissions = async ()=>{
    try{
        const response = await api.get(`/certificates/`);
        return response.data;
    }
    catch(error){
        throw error.response ? error.response.data : error;
        
    }
}
export const createAccountAgainstSubmission = async(data)=>{
    try{
        const response = await api.post(`/user-certificates/create-user-from-certificate/${data.id}`);
        return response.data;
    }
    catch(error){
        throw error.response ? error.response.data : error;
        
    } 
}


export const SubmitCertificate = async(data)=>{
    try{
        const response = await api.post(`/certificates/create`,data)
        return response.data;
    }
    catch(error){
        throw error.response ? error.response.data : error;
        
    }

} 


export const addUserProducts = async(data)=>{
    try{
        const response = await api.post(`/user-products/add-multiple`,data)
        return response.data;
    }
    catch(error){
        throw error.response ? error.response.data : error;
        
    }
}

export const updateUserApproval = async (userId, approved) => {
    try {
        const response = await api.put(`/users/approve`, { userId, approved: approved.approved }); 
             return response.data.user;
    } catch (error) {
      throw error;
    }
  };